import React, { JSX } from 'react';
import { LocationItem } from 'components/types/LocationTypes';
import ProvidersLocationsMap from './ProvidersLocationsMap';
import ProviderLocation from './ProviderLocation';

type ProviderLocationsProps = {
  locations: Array<LocationItem>;
  providerId: string;
  providerName: string;
  deptDays: { [key: string]: string[] };
  userDistance?: number;
};

const getOfficeLocationAnchorId = (city?: string): string => {
  const normalizedCity = (city || 'location')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return `office-location-${normalizedCity}`;
};

const ProviderLocations = (
  props: ProviderLocationsProps
): JSX.Element => {
  const {
    locations,
    providerId,
    providerName,
    deptDays,
    userDistance,
  } = props;

  const destinations = Array<Array<number>>();
  const hasMultipleLocations = locations.length > 1;

  locations.forEach((location) => {
    destinations.push([
      parseFloat(location?.fields?.Latitude?.value),
      parseFloat(location?.fields?.Longitude?.value),
    ]);
  });

  const anchoredCities = new Set<string>();

  return (
    <>
      {locations && (
        <div
          id="locations"
          className="profile-section provider-locations"
        >
          <h2>Locations</h2>

          {hasMultipleLocations && (
            <p>
              This provider practices at multiple locations. Please choose a
              location before scheduling.
            </p>
          )}

          <div
            id="map-container"
            className="provider-locations-map"
            data-coords={destinations}
          >
            <ProvidersLocationsMap
              coords={destinations}
              iconUrl="/images/location-icon-black.svg"
              searchType="providers"
            />
          </div>

          {locations.map((location, index) => {
            const city = location?.fields?.City?.value?.trim();
            const normalizedCity = city?.toLowerCase() || '';

            const isFirstLocationForCity =
              !!city && !anchoredCities.has(normalizedCity);

            if (isFirstLocationForCity) {
              anchoredCities.add(normalizedCity);
            }

            const locationAnchorId = isFirstLocationForCity
              ? getOfficeLocationAnchorId(city)
              : undefined;

            return (
              <ProviderLocation
                key={`location-${index}`}
                index={index}
                location={location}
                providerId={providerId}
                providerName={providerName}
                deptDays={deptDays}
                userDistance={userDistance}
                locationAnchorId={locationAnchorId}
              />
            );
          })}

          <div id="provider-location-modal-root"></div>
        </div>
      )}
    </>
  );
};

export default ProviderLocations;